// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { OptionAnalyzerChart } from '@front/chart/OptionAnalyzerChart';
import { BaseChartRactive } from './BaseChartRactive';
export class OptionAnalyzerChartRactive extends BaseChartRactive {
    getType() {
        return 'OptionAnalyzerChart';
    }
    onteardown() {
        this.terceraChart.detachOptionTrader();
        super.onteardown();
    }
    createChart() {
        return new OptionAnalyzerChart(this.context, super.get('terceraChartPanelContext'));
    }
}
